export * from '../../common/modules/core/services';
export * from './AttendanceService';
export * from './BookingService';
export * from './LocalService';
export * from './ClassService';
export * from './EmailService';
export * from './BookingHolidayService';
export * from './ScheduleService';
export * from './HolidayService';
export * from './HolRegisterService'


// WEBPACK FOOTER //
// ./src/holiday/services/index.ts